export default __webpack_public_path__ + "static/media/male-back.15cfc353.png";